/** Free text on a Discovery-generated Lead; never part of Discovery answers or pricing. */
export const CUSTOMER_NOTES_MAX_LENGTH = 2000;
export function normalizeCustomerNotes(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  return value.slice(0, CUSTOMER_NOTES_MAX_LENGTH).trim() || undefined;
}
